export const useBonusCancel = () => {
  const isNeedCancelConfirm = ref(false);

  const askToConfirmCancel = () => {
    isNeedCancelConfirm.value = true;
  };
  const removeConfirmCancel = () => {
    isNeedCancelConfirm.value = false;
  };

  return {
    isNeedCancelConfirm,
    askToConfirmCancel,
    removeConfirmCancel,
  };
};
